import { Link } from "react-router-dom";

const stats = [
  { value: "1,200+", label: "影视作品", icon: "ri-film-line" },
  { value: "680+", label: "剧集内容", icon: "ri-tv-2-line" },
  { value: "240+", label: "综艺节目", icon: "ri-mic-line" },
  { value: "每日更新", label: "影视资讯", icon: "ri-newspaper-line" },
];

export default function SiteIntro() {
  return (
    <section className="rounded-lg bg-accent-50 border border-accent-100 p-6 md:p-10">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
        <div>
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
            <i className="ri-leaf-line"></i>
            关于蘑菇TV
          </span>
          <h2 className="mt-4 font-heading font-bold text-2xl md:text-3xl text-foreground-950 leading-tight">
            让好内容，触手可及
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
            蘑菇TV 是一个面向影迷的影视娱乐平台，汇集电影、电视剧与综艺节目内容。你可以按分类浏览、使用多维度筛选与全站搜索，快速找到感兴趣的作品，查看详尽的剧情介绍与剧集信息，并阅读最新影视资讯。
          </p>
          <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
            平台专注于内容浏览与资讯阅读体验，播放相关功能以演示形式呈现，不与真实播放或下载接口对接。
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-information-line text-lg"></i>
              了解我们
            </Link>
            <Link
              to="/news"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-accent-200 text-accent-700 text-sm font-semibold hover:bg-accent-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-newspaper-line text-lg"></i>
              影视资讯
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {stats.map((item) => (
            <div
              key={item.label}
              className="rounded-lg bg-background-50 border border-accent-100 p-5"
            >
              <span className="w-10 h-10 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <p className="mt-3 font-heading font-bold text-xl md:text-2xl text-foreground-950">
                {item.value}
              </p>
              <p className="text-xs text-foreground-500 mt-0.5">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}